import PageView from '@/layouts/PageView'
import routerMap from '@/router/async/router.map'
import {mergeI18nFromRoutes} from '@/utils/i18n'
import Router from 'vue-router'
import deepMerge from 'deepmerge'
import basicOptions from '@/router/async/config.async'


//应用配置
let appOptions = {
  router: undefined,
  i18n: undefined,
  store: undefined
}

/**
 * 设置应用配置
 * @param options
 */
function setAppOptions(options) {
  const {router, store, i18n} = options
  appOptions.router = router
  appOptions.store = store
  appOptions.i18n = i18n
}


 // 调用内部_parseRoutes函数处理路由配置
//  接收两个参数：
// routesConfig: 路由配置数组
// routerMap: 路由组件映射表
  // routesConfig: 路由配置数组，包含path、name等路由信息
  // routerMap: 路由组件映射表，包含预定义的路由组件
function parseRoutes(routesConfig, routerMap) {
  const routes = _parseRoutes(routesConfig, routerMap)
  return routes
}


function parseRoute(item, routerMap) {
  let router = undefined, routeCfg = {}
  if (typeof item === 'string' && routerMap[item]) {
    router = routerMap[item]
    routeCfg = {path: router.path || item, router: item}
  }
  else if (typeof item === 'object') {
    router = routerMap[item.path]
    if (!router) {
      router = routerMap[item.router]
    }
    routeCfg = item
  }
  if (!router) {
    // console.warn(`can't find register for router ${routeCfg.router}, please register it in advance.`)
    router = typeof item === 'string' ? {path: item, name: item} : item
  }
  // 从 router 和 routeCfg 解析路由
  const route = {
    path: routeCfg.path || router.path || routeCfg.router,
    name: routeCfg.name || router.name,
    component: router.component || PageView,
    redirect: routeCfg.redirect || router.redirect,
    meta: Object.assign({}, routeCfg.meta || {}, {
      authority: routeCfg.authority || router.authority || '*',
      icon: routeCfg.icon || router.icon,
      page: routeCfg.page || router.page,
      link: routeCfg.link || router.link
    })
  }
  if (routeCfg.invisible || router.invisible) {
    route.meta.invisible = true
  }
  return route;
}


/**
 * 根据 路由配置 和 路由组件注册 解析路由
 * @param routesConfig 路由配置
 * @param routerMap 本地路由组件注册配置
 */
function _parseRoutes(routesConfig, routerMap) {
  let routes = []
  routesConfig.forEach(item => {
    // 获取注册在 routerMap 中的 router，初始化 routeCfg
    const route = parseRoute(item, routerMap)
    if (item.children && item.children.length > 0) {
      route.children = _parseRoutes(item.children, routerMap)
    }
    routes.push(route)
  })
  return routes
}


/**
 * 将/节点下的所有路径以/开头的节点直接挂到/之下，以保证路由规则正确
 * @param routes
 * @return {*}
 */
function flatternRootRoutes(routes) {
  const rootRoute = routes.find(r => r.path === "/")
  // console.info("Source routes", routes)
  _flatternRoutes(rootRoute, rootRoute.children || [])
  // 因为config.async中预先定义了所有的路由，在routerUtil又通过loadRoutes加载了缓存的路由，会出现重复的项目，所以要对整个routes列表去重
  _flatternRoutes(rootRoute, routes)
  // console.info("Flatterned routes", routes)

  /*
  const sortedRootRoutes = routes.sort(function (a, b) {
    const slashesOfA = a.path ? a.path.split("/").length : 0
    const slashesOfB = b.path ? b.path.split("/").length : 0
    return slashesOfB - slashesOfA
  })
  */
  return routes
}

/**
 * 固定的最上层导航（在flattern的时候不要处理这些导航，避免将这几个页嵌入带菜单的布局中）
 * @type {string[]}
 */
const STATIC_ROOT_ROUTES = ['/login', '/403', '/404'];

function _flatternRoutes(rootRoute, routes) {
  for (let i = routes.length - 1; i >= 0; --i) {
    const route = routes[i]
    if (route.path && route.path !== "/" && route.path.startsWith("/") && STATIC_ROOT_ROUTES.indexOf(route.path) === -1) {
      // append to rootRoute
      route.path = route.path.substring(1)
      const duplicateRoute = rootRoute.children.find(c => c.path === route.path)
      if (!duplicateRoute) {
        // 如果发现了重复的路由，以先定义的路由为准
        rootRoute.children.push(route)
      }
      routes.splice(i, 1)
    }
    if (route.children) {
      _flatternRoutes(rootRoute, route.children)
    }
  }
}

/**
 * 加载路由
 * @param routesConfig {{path: string, router: string, children: *[], name: string}[]} 路由配置
 */
function loadRoutes(routesConfig) {
  // console.log('测试路由',routesConfig)
  //兼容 0.6.1 以下版本
  /*************** 兼容 version < v0.6.1 *****************/
  if (arguments.length > 0) {
    const arg0 = arguments[0]
    if (arg0.router || arg0.i18n || arg0.store) {
      routesConfig = arguments[1]
      // console.error('the usage of signature loadRoutes({router, store, i18n}, routesConfig) is out of date, please use the new signature: loadRoutes(routesConfig).')
      // console.error('方法签名 loadRoutes({router, store, i18n}, routesConfig) 的用法已过时, 请使用新的方法签名 loadRoutes(routesConfig)。')
    }
  }
  /*************** 兼容 version < v0.6.1 *****************/

        // 从应用配置获取router和store实例

  const {router, store} = appOptions

  // 如果 routesConfig 有值，则更新到本地，否则从本地获取
  if (routesConfig) {
    store.commit('account/setRoutesConfig', routesConfig)
  }
  else {
        // 否则从Vuex store获取已保存的路由配置
    routesConfig = store.getters['account/routesConfig']
    // console.info("Loaded local routes", routesConfig)
  }

  // 如果开启了异步路由，则加载异步路由配置
  const asyncRoutes = store.state.setting.asyncRoutes
  if (asyncRoutes) {
    if (routesConfig && routesConfig.length > 0) {
            // 1. 解析路由配置
      const routes = parseRoutes(routesConfig, routerMap)
      // console.info("Parsed routes", routes)
            // 2. 合并基础路由和动态路由
      const finalRoutes = mergeRoutes(basicOptions.routes, routes)
      // console.info("Merged routes", routes)
      // const finalRoutes = mergedRoutes.sort(function (a, b) {
      //   const slashesOfA = a.path ? a.path.split("/").length : 0
      //   const slashesOfB = b.path ? b.path.split("/").length : 0
      //   return slashesOfB - slashesOfA
      // })
            // 3. 格式化路由路径和权限
      formatRoutes(finalRoutes)
            // 4. 更新路由器的配置
      router.options = {...router.options, routes: finalRoutes}
      router.matcher = new Router({...router.options, routes: []}).matcher
      // console.info("Final routes", finalRoutes)

      // 先创建菜单，然后将根节点下的路由展开，以保证后台加载的菜单可以正确匹配到路由
      updateMenuData(router.options.routes)

      // 后台提供的数据不会按照vue路由的规则来逐级匹配，又要保证功能页面继承首页('/')的布局，所以要把所有以/开头的页面直接挂到首页下面
      // 这一步需要在更新菜单数据之后执行
            // 6. 扁平化根路由下的所有路径
      const flatRoutes = flatternRootRoutes(finalRoutes)
            // 7. 动态添加路由
      router.addRoutes(flatRoutes)
      return
    }
  }
  // 如果不启用异步路由，只更新菜单数据
  updateMenuData(router.options.routes)
}


function duplicateRoute(route) {
  return {
    path: route.path,
    name: route.name,
    meta: route.meta ? JSON.parse(JSON.stringify(route.meta)) : undefined,
    children: route.children ? duplicateRoutes(route.children || []) : undefined
  };
}

function duplicateRoutes(routes) {
  return routes.map(duplicateRoute)
}

/**
 * 更新全局菜单数据
 * @param routes
 */
function updateMenuData(routes) {
  // 应用配置
  const {store, i18n} = appOptions
  // 复制路由数据，否则flatternRootRoutes中的更改会影响菜单
  const routesCopy = duplicateRoutes(routes)
  // 提取路由国际化数据
  mergeI18nFromRoutes(i18n, routesCopy)
  // 初始化Admin后台菜单数据
  const rootRoute = routesCopy.find(item => item.path === '/')
  const menuRoutes = ((rootRoute && rootRoute.children) || []).filter(item => !item.meta || item.meta.menu !== false)
  if (menuRoutes) {
    store.commit('setting/setMenuData', menuRoutes)
  }
}

/**
 * 合并路由
 * @param target {Route[]}
 * @param source {Route[]}
 * @returns {Route[]}
 */
function mergeRoutes(target, source) {
  const routesMap = {}
  target.forEach(item => routesMap[item.path] = item)
  source.forEach(item => routesMap[item.path] = item)
  return Object.values(routesMap)
}

/**
 * 深度合并路由
 * @param target {Route[]}
 * @param source {Route[]}
 * @returns {Route[]}
 */
function deepMergeRoutes(target, source) {
  // 映射路由数组
  const mapRoutes = routes => {
    const routesMap = {}
    routes.forEach(item => {
      routesMap[item.path] = {
        ...item,
        children: item.children ? mapRoutes(item.children) : undefined
      }
    })
    return routesMap
  }
  const tarMap = mapRoutes(target)
  const srcMap = mapRoutes(source)

  // 合并路由
  const merge = deepMerge(tarMap, srcMap)

  // 转换为 routes 数组
  const parseRoutesMap = routesMap => {
    return Object.values(routesMap).map(item => {
      if (item.children) {
        item.children = parseRoutesMap(item.children)
      }
      else {
        delete item.children
      }
      return item
    })
  }
  return parseRoutesMap(merge)
}

/**
 * 格式化路由
 * @param routes 路由配置
 */
function formatRoutes(routes) {
  routes.forEach(route => {
    const {path} = route
    if (!path.startsWith('/') && path !== '*') {
      route.path = '/' + path
    }
  })
  formatAuthority(routes)
}

/**
 * 格式化路由的权限配置
 * @param routes 路由
 * @param pAuthorities 父级路由权限配置集合
 */
function formatAuthority(routes, pAuthorities = []) {
  routes.forEach(route => {
    const meta = route.meta
    const defaultAuthority = pAuthorities[pAuthorities.length - 1] || {permission: '*'}
    if (meta) {
      let authority = {}
      if (!meta.authority) {
        authority = defaultAuthority
      }
      else if (typeof meta.authority === 'string') {
        authority.permission = meta.authority
      }
      else if (typeof meta.authority === 'object') {
        authority = meta.authority
        const {role} = authority
        if (typeof role === 'string') {
          authority.role = [role]
        }
        if (!authority.permission && !authority.role) {
          authority = defaultAuthority
        }
      }
      meta.authority = authority
    }
    else {
      const authority = defaultAuthority
      route.meta = {authority}
    }
    route.meta.pAuthorities = pAuthorities
    if (route.children) {
      formatAuthority(route.children, [...pAuthorities, route.meta.authority])
    }
  })
}

/**
 * 从路由 path 解析 i18n key
 * @param path
 * @returns {*}
 */
function getI18nKey(path) {
  const keys = path.split('/').filter(item => !item.startsWith(':') && item != '')
  keys.push('name')
  return keys.join('.')
}

/**
 * 加载导航守卫
 * @param guards
 * @param options
 */
function loadGuards(guards, options) {
  const {beforeEach, afterEach} = guards
  const {router} = options
  beforeEach.forEach(guard => {
    if (guard && typeof guard === 'function') {
      router.beforeEach((to, from, next) => guard(to, from, next, options))
    }
  })
  afterEach.forEach(guard => {
    if (guard && typeof guard === 'function') {
      router.afterEach((to, from) => guard(to, from, options))
    }
  })
}

export {parseRoutes, loadRoutes, formatAuthority, getI18nKey, loadGuards, deepMergeRoutes, formatRoutes, setAppOptions}
